import type {
  AuthSession,
  ChangePasswordRequest,
  ChangePasswordResponse,
  LoginRequest,
  MeResponse,
  RegisterRequest,
  SetWithdrawalPasswordRequest,
  UpdateProfileRequest,
} from '@/contracts/auth.contract'
import { http, request } from './http/client'

/**
 * 認證端點。
 *
 * 只負責「怎麼跟後端講話」，不碰狀態也不碰畫面。
 * 路徑與 `api/src/modules/auth/auth.routes.ts` 一一對應。
 */

const BASE = '/api/v1/auth'

export const authApi = {
  register(payload: RegisterRequest): Promise<AuthSession> {
    return request<AuthSession>({ method: 'POST', url: `${BASE}/register`, data: payload })
  },

  login(payload: LoginRequest): Promise<AuthSession> {
    return request<AuthSession>({ method: 'POST', url: `${BASE}/login`, data: payload })
  },

  /**
   * 用 httpOnly cookie 換新的 access token。
   *
   * 刻意用裸的 `http` 而非 `request()` 包裝 —— 這支會在 response interceptor
   * 內部被呼叫，走一般管線會繞回攔截器造成遞迴。
   */
  async refresh(): Promise<AuthSession> {
    const response = await http.post<{ ok: true; data: AuthSession }>(`${BASE}/refresh`)
    return response.data.data
  },

  async logout(): Promise<void> {
    await http.post(`${BASE}/logout`)
  },

  me(): Promise<MeResponse> {
    return request<MeResponse>({ method: 'GET', url: `${BASE}/me` })
  },

  updateProfile(payload: UpdateProfileRequest): Promise<MeResponse> {
    return request<MeResponse>({ method: 'PATCH', url: `${BASE}/profile`, data: payload })
  },

  setWithdrawalPassword(payload: SetWithdrawalPasswordRequest): Promise<MeResponse> {
    return request<MeResponse>({
      method: 'POST',
      url: `${BASE}/withdrawal-password`,
      data: payload,
    })
  },

  changePassword(payload: ChangePasswordRequest): Promise<ChangePasswordResponse> {
    return request<ChangePasswordResponse>({
      method: 'POST',
      url: `${BASE}/change-password`,
      data: payload,
    })
  },
}
